<template>
  <va-card :title="$t('menu.users_web')">
    <div class="row">
      <div class="flex xs12 md4">
        <va-input
          v-model="searchName"
          :placeholder="$t('tables.searchByUserWeb')"
          removable
        >
        </va-input>
      </div>

      <div class="flex md1">
        <va-button
          small
          color="secondary"
          icon="fa fa-search"
          class="ma-2"
          @click="readItems(page = 0, searchName)"
        >
          {{ $t('menu.search') }}
        </va-button>
      </div>

      <div class="flex xs12 md3 offset--md3">
        <va-select
          v-model="perPage"
          :value="perPage"
          :label="$t('tables.perPage')"
          :options="perPageOptions"
        />
      </div>

      <div class="flex xs12 sm3">
        <va-button
          medium
          inline
          color="secondary"
          icon="fa fa-plus"
          class="ma-0"
          to="/admin/forms/form-users-web"
        >
          {{ $t('menu.new') }}
        </va-button>
      </div>
    </div>
    
    <div v-show="loading" class="text--center pb-4">
      <div class="flex-center spinner-box">
        <slot name="loading">
          <spring-spinner
            slot="loading"
            :animation-duration="currentDuration"
            :is="spload.name"
            :color="spinnersColor"
            :size="config.size"
          />
        </slot>
      </div>
    </div>

    <va-data-table
      :fields="fields"
      :data="data"
      :per-page="parseInt(perPage)"
      :total-pages="parseInt(totalPages)"
      api-mode
      v-show="!loading"
      @page-selected="readItems"
    >
      <template slot="actions" slot-scope="props">
        <va-button
          small
          inline
          color="green"
          icon="fa fa-edit"
          class="ma-0"
          :to="{ name: 'form-users-web', params: { id: props.rowData.id } }" 
        >
          {{ $t('menu.edit') }}
        </va-button>
        <va-button 
          small 
          inline 
          color="danger" 
          icon="fa fa-remove"
          class="ma-0"
          @click="showModalRemove = true, codeUserWeb = props.rowData.id" 
        >
          {{ $t('tables.delete') }}
        </va-button>
      </template>
    </va-data-table>
    <va-modal
      v-model="showModalRemove"
      size="small"
      :title="$t('modal.remove')"
      :message="$t('modal.messageRemoveUser')"
      :okText="$t('modal.confirm')"
      :cancelText="$t('modal.cancel')"
      @ok="remove(codeUserWeb)"
    />
  </va-card>
</template>

<script>

import UserWebAPI from '@/services/UserWebAPI'
import * as spinners from 'epic-spinners'

export default {
  components: {
    ...spinners,
  },
  data () {
    return {
      data: [],
      term: null,
      loading: false,
      config: {
        size: 80,
        group: 4,
        duration: 1500,
      },
      spinnersColor: this.$themes.secondary,
      currentDuration: 1500,
      showModalRemove: false,
      codeUserWeb: "",
      searchName: "",
      perPage: "10",
      totalPages: 0,
      perPageOptions: ['10', '20', '30', '50'],
      id: ''
    }
  },
  mounted () {
    this.readItems()
  },
  computed: {
    fields () {
      return [{
        name: 'id',
        title: this.$t('tables.users.id'),
        width: '10%',
      },
      {
        name: 'login',
        title: this.$t('tables.users.login'),
        width: '20%',
      },
      {
        name: 'name',
        title: this.$t('tables.users.name'),
        width: '30%',
      },
            {
        name: 'role.name',
        title: this.$t('tables.roles.name'),
        width: '20%',
      },
      {
        name: '__slot:actions',
        dataClass: 'text-right',
      }]
    },
    spload () {
      return spinners.ScalingSquaresSpinner
    }
  },
  watch: {
    perPage: function (newVal) {
      this.perPage = newVal
      this.readItems()
    },
    searchName: function (newVal) {
      if (!newVal) {
        this.readItems()
      }
    }
  },
  created () {
    this.readItems()
  },
  methods: {
    readItems(page = 0, searchName) {
      this.loading = true

      const params = {
        page: page,
        quantity: this.perPage,
        name: this.searchName
      }

      UserWebAPI.getFilteredUserWeb(params)
        .then(response => {
          this.totalPages = response.data.total_pages
          this.data = response.data.users
          this.loading = false
        })
    },
    remove (userWebId) {
      UserWebAPI.deleteUserWeb(userWebId)
        .then(response => {
          const rowItem = this.data.map((e) => e.id).indexOf(userWebId)
          this.data.splice(rowItem, 1)

          this.showToast(response.data.message, {
            icon: 'fa-thumbs-o-up',
            position: 'top-right',
            duration: 5000,
          })
        }).catch(e => {
          this.showToast(e.response.data.error, {
            icon: 'fa-thumbs-o-down',
            position: 'top-right',
            duration: 5000,
          })
      });
    }
  }
}
</script>